import React from 'react';
import { Box, Divider, Paper, Typography } from '@mui/material';

function capitalize(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

interface Props {
  readonly title: string;
  readonly titleMargin?: number;
  readonly id?: string;
  readonly children: React.ReactNode;
}

export default function AnnotationOptionsSection({ title, children }: Props) {
  return (
    <Paper sx={{ p: 2, mb: 3, bgcolor: 'backContrast.main' }}>
      <Typography variant="subtitle1" gutterBottom>
        {capitalize(title)}
      </Typography>
      <Divider />

      <div>{children}</div>
    </Paper>
  );
}

interface RowProps {
  readonly children: React.ReactNode;
}

export const AnnotationsOptionsRow = ({ children }: RowProps) => (
  <Box sx={{ mt: 2, display: 'flex', justifyContent: 'space-between' }}>{children}</Box>
);
